import React from "react";
export const ZIP_CODE_REGEX = /^\d{5}((-|\s)\d{4})?$/;
export const POSTAL_CODE_REGEX =
  /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/;
export const PARA_STAR_REGEX = /\*(.*?)\*/g;

const NORMAL = "normal";
const STYLED = "styled";

export const capitalize = (s) => {
  if (typeof s !== "string") {
    return "";
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const formatParagraph = (
  text,
  fontWeight = 900,
  textDecoration = "none",
  color = "inherit"
) => {
  const parts = text.split("*"); // Split text using '*' as a marker

  // Create an array of elements with appropriate styling
  const elements = parts.map((part, index) => {
    return index % 2 === 0 ? (
      <span key={index}>{part}</span> // Non-bold text
    ) : (
      <span
        style={{
          fontWeight: fontWeight,
          textDecoration: textDecoration,
          color: color,
        }}
        key={index}
      >
        {part}
      </span> // Bold text
    );
  });

  return elements;
};

export const formatText = (text, className) => {
  const parts = text.split("*"); // Split text using '*' as a marker

  // Create an array of elements with appropriate styling
  const elements = parts.map((part, index) => {
    return index % 2 === 0 ? (
      <span key={index}>{part}</span>
    ) : (
      <span className={className} key={index}>
        {part}
      </span>
    );
  });

  return elements;
};

export const extractKeyFromPath = (path) => {
  const extractFileNameWithExtension = /^\.\/(.+)\..+$/;
  const matchFileName = path.match(extractFileNameWithExtension);
  if (!matchFileName) {
    return "";
  }

  const fileNameWithoutExtension = matchFileName[1];
  const capitalizeFirstLetterOfWords = /\b\w/g;
  const removeNonAlphanumericChars = /[^a-zA-Z0-9]/g;

  const capitalizedFileNameWithoutExtension = fileNameWithoutExtension
    .replace(capitalizeFirstLetterOfWords, (match) => match.toUpperCase())
    .replace(removeNonAlphanumericChars, "");

  return capitalizedFileNameWithoutExtension;
};

export const processStringWithStyles = (text, styledClass, normalClass) => {
  const regex = PARA_STAR_REGEX;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(
        <span className={normalClass} key={`${NORMAL}-${lastIndex}`}>
          {text.substring(lastIndex, match.index)}
        </span>
      );
    }
    parts.push(
      <span className={styledClass} key={`${STYLED}-${match.index}`}>
        {match[1]}
      </span>
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(
      <span className={normalClass} key={`${NORMAL}-${lastIndex}`}>
        {text.substring(lastIndex)}
      </span>
    );
  }

  return parts;
};

/**
 * Checks if a specific path or segment exists as a full section
 * within the given pathname.
 *
 * This function ensures that the path is matched exactly as a section and not
 * as a partial substring. For example, '/section1' will match '/section1/2',
 * but '/section2' will not match '/section3/5'.
 *
 * @param {string} segment - The path or segment to match.
 * @param {string} pathname - The full pathname to check against.
 * @returns {boolean} - Returns `true` if the segment matches a section in the pathname, otherwise `false`.
 */
export const isSegmentInPath = (segment, pathname) => {
  // Create a regex that matches the segment followed by a `/` or end of the string
  const regex = new RegExp(`^${segment}(?:/|$)`);
  return regex.test(pathname);
};
